import React from 'react';
import InflationVolatilityWrapper from '../../components/InflationVolatilityWrapper/InflationVolatilityWrapper';
import DayYield from './DayYield.card';

const DayYieldCardWrapper = (props) => (
    <InflationVolatilityWrapper>
        <DayYield {...props} />
    </InflationVolatilityWrapper>
);

export default DayYieldCardWrapper;
